"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TCP_HOSTS_LIMIT = void 0;
exports.TCP_HOSTS_LIMIT = {
    lite: 0,
    plus_v2: 0,
    /** @deprecated */ pro: 0,
    pro_v2: 1,
    /** @deprecated */ premium: 0,
    premium_v2: 3,
    /** @deprecated */ ultimate: 0,
    ultimate_v2: Infinity,
};
//# sourceMappingURL=tcp.js.map